import axios from 'axios'
import {
  get,
  post,
  del,
  getfile
} from '@/http/request'
import {
  HOST
} from '@/http/config'

// 医药费二次报销列表
export function medicalReimbursementPatchList(params) {
  return get(`${HOST}medical-reimbursement/medicalReimbursementPage`, params)
}
// 年度下拉 
export function getYear(params) {
  return get(`${HOST}medical-reimbursement-batch/getYear`, params)
}
// 批次报销详情 
export function medicalReimbursementBatchGet(params) {
  return get(`${HOST}medical-reimbursement/medicalReimbursementGet/${params}`)
}
// 申请报销 
export function medicalReimbursementSave(params) {
  return post(`${HOST}medical-reimbursement/medicalReimbursementSave`, params)
}
// 根据id修改
export function expenseReimbursementUpdate(params) {
  return post(`${HOST}medical-reimbursement/expenseReimbursementUpdate`, params)
}
// 批次修改
export function batchUpdate(params) {
  return post(`${HOST}medical-reimbursement-batch/batchUpdate`, params)
}
// 获取部门/单位列表
export function getOrganizationList(params) {
  return get(`${HOST}organization-info/treeList/`, params)
}
// 查询用户 
export function getUserList(params) {
  return get(`${HOST}sys-user/list`, params)
}
// 发票查看更多
export function getMedicalAttachmentList(params) {
  return get(`${HOST}medical-reimbursement/getMedicalAttachmentList`, params)
}
// 年度报销列表
export function medicalReimbursementPage(params) {
  return get(`${HOST}medical-reimbursement/medicalReimbursementYearPage`, params)
}
// 年度报销详情
export function getReimbursementDetails(params) {
  return get(`${HOST}medical-reimbursement/medicalReimbursementGet/${params}`)
}
// 核算  
export function medicalReimbursementUpdate(params) {
  return post(`${HOST}medical-reimbursement/medicalReimbursementUpdate/${params}`)
}
// 导出
export function reimbursementExport(params) {
  return getfile(`${HOST}medical-reimbursement/export`, params)
}
// 我的医药费报销 
export function pcMedicalReimbursementUserList(params) {
  return get(`${HOST}medical-reimbursement-batch/pcMedicalReimbursementUserList`, params)
}

// 报销年度列表 下载模板
export function importTemplate() {
  return getfile(`${HOST}medical-reimbursement/importTemplate`)
}
// 导入医药费附件
export function importMedicalReimbursement(params) {
  return post(`${HOST}medical-reimbursement/importMedicalReimbursement`, params)
}

//组织结构树
export function getTreeList(params) {
  return get(`${HOST}organization-info/treeList/`, params)
}
// 删除医药费管理
export function deleteDisposition(params) {
  return del(`${HOST}medical-reimbursement/medicalReimbursementDelete/${params}`)
}


// WEBPACK FOOTER //
// ./src/views/MedicalFee/api/api.js